import ImgCover from '../../../../assets/about/cover-symetra.jpg'
import AILogo from '../../../../assets/about/followone-ai-w.svg'

const Cover = () => {
    return (
        <div id="cover" className="section cover" style={{ backgroundImage: `url(${ImgCover})` }}>

            <div className="cover-background"></div>

            <div className="cover-logo">
                <img src={AILogo} alt="Followone AI Logo" />
            </div>

            {/* <div className="cover-text">
                <h1>Followone Inc.<br />a Delaware Corporation</h1>
                <p>Located in downtown Bellevue, WA</p>
            </div> */}

            <div className="cover-text">
                <h1>About Us</h1>
                <p>Let's get to know each other.</p>
            </div>

            <div className="cover-addresses">
                <div>
                    <h4>Followone HQ</h4>
                    <table>
                        <tbody>
                            <tr>
                                <td><i className="fal fa-map-marker-alt"></i></td>
                                <td>
                                    500 108th AVE NE 1100<br />
                                    Bellevue, WA 98004
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <h4>Office Contact</h4>
                    <table>
                        <tbody>
                            <tr>
                                <td><i className="fal fa-envelope"></i></td>
                                <td>support@followone.com</td>
                            </tr>
                            <tr>
                                <td><i className="fal fa-globe"></i></td>
                                <td>https://followone.com</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>

                <div className="cover-addresses">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td></td>
                                <td>John Blig 
                                <br /> Managing Broker, TX 
                                <br /> Followone Real Estate, Inc.</td>
                            </tr>
                            <tr>
                                <td><i className="fal fa-phone-office"></i></td>
                                <td>+1 (210) 275-9994</td>
                            </tr>
                            <tr>
                                <td><i className="fal fa-envelope"></i></td>
                                <td>johnblig@gmail.com </td>
                            </tr>
                            <tr>
                                <td><i className="fal fa-map-marker-alt"></i></td>
                                <td>
                                    94 TRILLION CT.<br />
                                    BOERNE, TX 78006
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Cover;